<div [ngClass]="displayBlock?'full-height':''">
    <mat-progress-bar *ngIf="loadingIndicator"
                      mode="indeterminate"></mat-progress-bar>
</div>
